/**
 * Constants for dynamic test configuration section rendering.
 * Maps field type strings from testType.testBuilder.details.sections
 * to identifiers used by DynamicFieldRenderer.
 */
import { MULTI } from '../../../../general/Constants';

export const FIELD_TYPE = {
    HOSTNAME: 'hostname',
    TEXT: 'text',
    PASSWORD: 'password',
    NUMBER: 'number',
    INTEGER: 'integer',
    RADIO: 'radio',
    SELECT: 'select',
    BOOLEAN: 'boolean',
    WIFI_NETWORKS: 'wi-fi networks',
    WIFI_TESTS: 'wi-fi tests',
};

export const WIFI_NETWORKS_API = '/ipm/v1/admin/ssidConfig/';
export const WIFI_TESTS_API = '/ipm/v1/open/tests';
export const WIFI_TESTS_QUERY = { adapterType: MULTI };

export const NO_TEST_OPTION = { _id: '', name: 'No Test' };
